export default __webpack_public_path__ + "static/clover-11076dc823f33240108804add49f58ba.webp";